import React, { useEffect, useRef } from 'react';
import { PROCESS_STEPS } from '../data/siteData';

export default function Process() {
  const timelineRef = useRef(null);

  useEffect(() => {
    const el = timelineRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          const fill = el.querySelector('#procFill');
          if (fill) fill.classList.add('on');
          el.querySelectorAll('.pst, .pe').forEach((p) => p.classList.add('on'));
          obs.unobserve(el);
        }
      },
      { threshold: 0.18 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  const headerRef = useRef(null);
  useEffect(() => {
    const el = headerRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { el.classList.add('on'); obs.unobserve(el); } },
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section className="process-sec" id="process" aria-labelledby="process-heading">
      <div className="wrap">
        <div className="proc-top rv" ref={headerRef}>
          <div>
            <div className="chip" style={{ marginBottom: '.8rem' }}>⚡ How We Work</div>
            <h2 id="process-heading" style={{ fontSize: 'clamp(1.9rem,3.2vw,2.6rem)', fontWeight: 900, letterSpacing: '-.04em', color: 'var(--text)', margin: '.35rem 0 .65rem' }}>
              Our Delivery Process
            </h2>
            <p style={{ color: 'var(--body)', maxWidth: 480, lineHeight: 1.8 }}>
              A proven 5-step framework that delivers quality, speed, and transparency — from first call to production deployment.
            </p>
          </div>
          <a
            href="https://wa.me/918123629993?text=I'd like to start a project with JSDevBrains"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-green"
          >
            Start a Project →
          </a>
        </div>

        <div className="proc-timeline" id="procTimeline" ref={timelineRef}>
          <div className="proc-line">
            <div className="proc-fill" id="procFill" />
          </div>

          {PROCESS_STEPS.map((step, i) => (
            <div className="proc-step pst" key={step.n} style={{ transitionDelay: `${i * 0.12}s` }}>
              <div className="ps-dot">
                <div className="ps-dot-inner">{step.icon}</div>
              </div>
              <div className="ps-card pe" style={{ transitionDelay: `${i * 0.14}s` }}>
                <div className="ps-n">{step.n}</div>
                <h3 className="ps-title">{step.title}</h3>
                <p className="ps-desc">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
